import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { ExternalLink, SourceLink } from '../../src/components';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`From time to time, it is permissible to provide user feedback via the runtimes `}<ExternalLink href="https://developer.mozilla.org/en-US/docs/Web/API/Console" mdxType="ExternalLink">{`Console API`}</ExternalLink>{`. The primary usecase is to provide detailed error tracking in production or staging environments, and technical feedback in development environments.`}</p>
    <p>{`To ensure the relevant information is displayed, the `}<inlineCode parentName="p">{`LogManager`}</inlineCode>{` provides three methods of outputting to the console:`}</p>
    <ol>
      <li parentName="ol">{`All environments`}</li>
      <li parentName="ol">{`Development environment only`}</li>
      <li parentName="ol">{`Non-development environments`}</li>
    </ol>
    <h2>{`Configuration`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`LogManager`}</inlineCode>{` uses the `}<inlineCode parentName="p">{`mode`}</inlineCode>{` configuration value which defaults to `}<inlineCode parentName="p">{`production`}</inlineCode>{`. If you are in a development environment set `}<inlineCode parentName="p">{`mode`}</inlineCode>{` to `}<inlineCode parentName="p">{`local`}</inlineCode>{`.`}</p>
    <h2>{`Usage`}</h2>
    <SourceLink href="https://github.com/xedi/sdk-js/blob/master/src/Logger/LogManager.ts" mdxType="SourceLink"><InlineCode mdxType="InlineCode">LogManager</InlineCode></SourceLink>, <SourceLink href="https://github.com/xedi/sdk-js/blob/master/src/Logger/Logger.ts" mdxType="SourceLink"><InlineCode mdxType="InlineCode">Logger</InlineCode></SourceLink> and <SourceLink href="https://github.com/xedi/sdk-js/blob/master/src/Logger/NullLogger.ts" mdxType="SourceLink"><InlineCode mdxType="InlineCode">NullLogger</InlineCode></SourceLink> all implement the <SourceLink href="https://github.com/xedi/sdk-js/blob/master/src/Interfaces/Logger.ts" mdxType="SourceLink"><InlineCode mdxType="InlineCode">LoggerInterface</InlineCode></SourceLink> which requires implementations of 5 of the Console API's functions:
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`log`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`error`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`debug`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`info`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`warn`}</inlineCode></li>
    </ul>
    <p>{`These all have the same method signature as the Console API.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`/**
 * Logger
 */
interface Logger {
    log(message?: any, ...optionalParams: any[]): void;
    info(message?: any, ...optionalParams: any[]): void;
    debug(message?: any, ...optionalParams: any[]): void;
    error(message?: any, ...optionalParams: any[]): void;
    warn(message?: any, ...optionalParams: any[]): void;
};
`}</code></pre>
    <p>{`To output to the console only in a development environment use the `}<inlineCode parentName="p">{`DevelopmentLogger`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`this.logger.dev.log(
    'These are not the droids you are looking for',
    droids
);
`}</code></pre>
    <p>{`To output to the console only in a non-development environments use the `}<inlineCode parentName="p">{`ProductionLogger`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`this.logger.production.log(
    'These are not the droids you are looking for',
    droids
);
`}</code></pre>
    <p>{`Finally, to output to the console in all environments use the LogManager.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`this.logger.log(
    'These are not the droids you are looking for',
    droids
);
`}</code></pre>
    <h2>{`Registration`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`LogManager`}</inlineCode>{` is registered as `}<inlineCode parentName="p">{`logger`}</inlineCode>{` against the application `}<inlineCode parentName="p">{`Container`}</inlineCode>{`. It is also exposed statically as `}<inlineCode parentName="p">{`Log`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`Xedi.Log.dev.log(
    'These are not the droids you are looking for',
    droids
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      